import { NOTIFICATIONS_ROUTES } from "./config";

export const NOTIFICATIONS_TABS = {
    HISTORY: "History",
    CUSTOM: "Custom notification",
    SETTINGS: "Settings",
};

export const NOTIFICATIONS_TAB_LINKS = {
    [NOTIFICATIONS_TABS.HISTORY]: NOTIFICATIONS_ROUTES.HISTORY,
    [NOTIFICATIONS_TABS.CUSTOM]: NOTIFICATIONS_ROUTES.CUSTOM,
    [NOTIFICATIONS_TABS.SETTINGS]: NOTIFICATIONS_ROUTES.SETTINGS,
};